<template lang="pug">
#visualizar-monitoramento-socioambiental(v-if='monitoramento')
    BaseHeader(
        :titulo='territorio.nome',
        :exibeBotao='false',
        :voltarPara='voltarPara'
    )
    .view-container.alinhamento-secao
        BlocoAlertaVisualizarMonitoramentoSocioambiental
    BlocoDadosGeraisTerritorioMonitoramento(:monitoramento='monitoramento')
    .dados-territorio-monitoramento__container
        .dados-territorio-monitoramento__lista-item
            .dados-territorio-monitoramento-dados
                .dados-territorio-monitoramento-dados-item-inteiro(v-if='usuarioLogado.paisGrupo === ambientes.PARAGUAY')
                    h3 {{ $t('mensagens.territorio.dadosDoTerritorio') }}
                    BlocoDadosTerritorioMonitoramentoSocioambientalParaguai(
                        :territorio='monitoramento.territorio',
                        :monitoramento='monitoramento'
                    )
                .dados-territorio-monitoramento-dados-item(v-if='usuarioLogado.paisGrupo !== ambientes.PARAGUAY')
                    h3 {{ $t('mensagens.territorio.dadosDoTerritorio') }}
                    BlocoDadosTerritorioMonitoramentoSocioambiental(
                        :territorio='monitoramento.territorio',
                        :monitoramento='monitoramento'
                    )
                .dados-territorio-monitoramento-dados-item(v-if='usuarioLogado.paisGrupo !== ambientes.PARAGUAY')
                    h3 {{ $t('mensagens.comuns.carsVinculados') }}
                    BlocoDadosCarVinculadosMonitoramentoSocioambiental(
                        :cars='monitoramento.carsApi',
                        :monitoramento='monitoramento'
                    )
    .view-container
        BlocoHistoricoMonitoramento(:monitoramento='monitoramento')
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoCategoriaMonitoramentoAgricola from '@/components/monitoramento/BlocoCategoriaMonitoramentoAgricola';
import BlocoDadosGeraisTerritorioMonitoramento from '@/components/monitoramento/BlocoDadosGeraisTerritorioMonitoramento';
import BlocoDadosTerritorioMonitoramentoSocioambiental from '@/components/monitoramento/BlocoDadosTerritorioMonitoramentoSocioambiental';
import BlocoDadosTerritorioMonitoramentoSocioambientalParaguai from '@/components/monitoramento/BlocoDadosTerritorioMonitoramentoSocioambientalParaguai';
import BlocoAlertaVisualizarMonitoramentoSocioambiental from '@/components/monitoramento/BlocoAlertaVisualizarMonitoramentoSocioambiental';
import ListaAreaMonitoradaSocioambiental from '@/components/monitoramento/ListaAreaMonitoradaSocioambiental';
import BlocoHistoricoMonitoramento from '@/components/monitoramento/BlocoHistoricoMonitoramento';
import BlocoDadosCarVinculadosMonitoramentoSocioambiental from '@/components/monitoramento/BlocoDadosCarVinculadosMonitoramentoSocioambiental';

import MonitoramentoSocioambientalService from '@/services/MonitoramentoSocioambientalService.js';
import { mapState } from 'vuex';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'VisualizarMonitoramentoSocioambiental',
    components: {
        BaseHeader,
        BlocoCategoriaMonitoramentoAgricola,
        BlocoDadosGeraisTerritorioMonitoramento,
        BlocoDadosTerritorioMonitoramentoSocioambiental,
        BlocoAlertaVisualizarMonitoramentoSocioambiental,
        ListaAreaMonitoradaSocioambiental,
        BlocoHistoricoMonitoramento,
        BlocoDadosCarVinculadosMonitoramentoSocioambiental,
        BlocoDadosTerritorioMonitoramentoSocioambientalParaguai
    },
    computed: {
        ...mapState(['usuarioLogado'])
    },
    data() {
        return {
            voltarPara: {
                route: 'MonitoramentoSocioambiental'
            },
            idAreaMonitorada: this.$route.params.idAreaMonitorada,
            monitoramento: null,
            territorio: null,
            ambientes: AmbientesEmpresas
        };
    },
    created() {
        this.fetchAreaMonitorada();
        this.validarRotaComParametro();
        this.$store.dispatch('processarEventoGoogleAnalytics', { eventLabel: 'VISUALIZAR_M_SOCIO', pageTitle: 'VISUALIZAR_M_SOCIO', routeName: this.$route?.name, routePath: this.$route?.path });
    },

    methods: {
        async fetchAreaMonitorada() {
            try {
                const { data } =
                    await MonitoramentoSocioambientalService.buscarAreaMonitoradaPorId(
                        this.idAreaMonitorada
                    );
                this.monitoramento = data;
                this.territorio = data.territorio;
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.monitoramentoAgricola.erros.buscarMonitoramento')
                });
            }
        },
        validarRotaComParametro() {
            if (this.$route.params.idAreaMonitorada && this.$route.params.voltarHome) {
                this.voltarPara.route = 'Home';
            }
        }
    }
};
</script>
<style lang="scss" scoped>
#visualizar-monitoramento-socioambiental {
    height: calc(100vh - 55px);
    overflow-y: auto;
    .alinhamento-secao {
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .dados-territorio-monitoramento__container {
        margin: 18px 5px 10px 5px;
        h3 {
            margin-bottom: 10px;
            margin-top: 10px;
            color: var(--black);
        }
        .dados-territorio-monitoramento__lista-item {
            padding: 0 16px;
        }

        .dados-territorio-monitoramento-dados {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;

            .dados-territorio-monitoramento-dados-item {
                max-height: 250px;
                width: 49.25%;

                &:last-child {
                    margin: 2px 0px;
                }
            }

            .dados-territorio-monitoramento-dados-item-inteiro {
                max-height: 200px;
                width: 100%;

                &:last-child {
                    margin: 2px 0px;
                }
            }
        }
    }
}
</style>
